import {get} from "lodash";
import axios from 'axios';
import * as qs from 'qs';
import {Resource} from 'i18next';
import SiteHeader from './compontents/site-header';
import Dropdown from './compontents/dropdown';
import * as LazyLoad from 'vanilla-lazyload/dist/lazyload';
import * as i18next from 'i18next/i18next.js';
import Modal from "./compontents/modal";
import ViewPort from "./viewport";
import Tabs from "./compontents/tabs";
import blocks from '../../blocks/js/blocks';
import Wishlist from "./compontents/wishlist";
import ProductFilters from "./compontents/product-filters";
import SingleProduct from "./compontents/pages/single-product";
import Gallery from "./compontents/gallery";
import ArchiveManufacturers from "./compontents/pages/archive-manufacturers";
import MobileSearch from './compontents/mobile-search';
import TenderSorting from "./compontents/tender-sorting";

declare global {
  interface Window {
    pp: {
      data: Record<string, any>;
      translations: Record<string, any>;
    };
    google: any
  }
}
declare let __webpack_public_path__: string;

export default class App {
  static instance: App;

  static init(): void {
    if (!App.instance) {
      App.instance = new App();
    }
  }

  constructor() {
    App._loadTranslations();

    ViewPort.setBreakpoints({
      xs: 0,
      sm: 540,
      md: 768,
      lg: 1024,
      xl: 1200
    });

    __webpack_public_path__ = App.getData('publicPath');

    axios.defaults.baseURL = App.getData('ajaxUrl');
    axios.interceptors.request.use(config => {
      config.paramsSerializer = params => qs.stringify(params);
      return config;
    });

    window.addEventListener('load', () => {
      new SiteHeader(document.querySelector('._js-header'));
      new MobileSearch(document.querySelector('._js-header'));
    });

    new LazyLoad();

    blocks();
    Wishlist.factory();
    Modal.factory();
    Tabs.factory();
    ProductFilters.factory();
    TenderSorting.factory();
    SingleProduct.factory();
    ArchiveManufacturers.factory();
    Gallery.factory();
  }

  public static getData(key: string): any {
    return get(window.pp.data, key);
  }

  private static _loadTranslations(): void {
    const translationResources: Resource = {};
    translationResources[App.getData('lang')] = {
      translation: window.pp.translations
    };

    i18next.init({
      lng: App.getData('lang'),
      initImmediate: false,
      resources: translationResources
    });
  }
}

App.init();